<template>

    <div class="quote pl-5 py-2 md:py-4">

        <Paragraph v-html="text"/>

        <Paragraph v-if="author" class="mt-8">
            - {{ author }}
        </Paragraph>

    </div>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'
    import Paragraph from '../Paragraph.vue'

    export default defineComponent({
        name: 'Quote',
        components: {
            Paragraph
        },
        props: {
            text: { type: String, required: true },
            author: { type: String, required: false }
        }
    })

</script>

<style lang="scss">

    @include component(quote) {

        border-left: solid #E0E0E0 1px;

    }

</style>
